import src from "IMAGE";
export default { src, width: 544, height: 2, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
